/* eslint-disable */
const dotize = {};

dotize.convert = function (obj, prefix) {
  let newObj = {};
  if ((!obj || typeof obj !== 'object') && !Array.isArray(obj)) {
    if (prefix) {
      newObj[prefix] = obj;
      return newObj;
    }
    return obj;
  }

  function isNumber(f) {
    return !isNaN(parseInt(f, 10));
  }

  function isEmptyObj(obj) {
    for (const prop in obj) {
      if (Object.hasOwnProperty.call(obj, prop)) { return false; }
    }
  }

  function getFieldName(field, prefix, isRoot, isArrayItem, isArray) {
    if (isArray) {
      return (prefix || '') + (isNumber(field) ? `[${field}]` : (isRoot ? '' : '.') + field);
    } else if (isArrayItem) {
      return `${prefix || ''}[${field}]`;
    }
    return (prefix ? `${prefix}.` : '') + field;
  }

  return (function recurse(o, p, isRoot) {
    const isArrayItem = Array.isArray(o);
    for (const f in o) {
      const currentProp = o[f];
      if (currentProp && typeof currentProp === 'object') {
        if (Array.isArray(currentProp)) {
          newObj = recurse(currentProp, getFieldName(f, p, isRoot, false, true), isArrayItem);
        } else if (isArrayItem && isEmptyObj(currentProp) === false) {
          newObj = recurse(currentProp, getFieldName(f, p, isRoot, true)); // array item object
        } else if (isEmptyObj(currentProp) === false) {
          newObj = recurse(currentProp, getFieldName(f, p, isRoot)); // object
        } else {
          //
        }
      } else if (isArrayItem || isNumber(f)) {
        newObj[getFieldName(f, p, isRoot, true)] = currentProp; // array item primitive
      } else {
        newObj[getFieldName(f, p, isRoot)] = currentProp; // primitive
      }
    }

    return newObj;
  }(obj, prefix, true));
};

export default dotize;
